import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { responseInterceptor } from "./services/axios/responseInterceptor";
import { requestInterceptor } from "./services/axios/requestInterceptor";
import { useStrictMode } from "./utils/generalData";

// Axios interceptors request for add backend host
requestInterceptor();

// Axios interceptor response for refresh token
const auth_tk = JSON.parse(localStorage.getItem("auth_token"));
responseInterceptor(auth_tk);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {useStrictMode ? (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    ) : (
      <App />
    )}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
